export default "__VITE_ASSET__Chmxt8Nr__"